/*eslint no-undef: "error"*/
<template>
  <div>
      <gmap-map :center="center" ref="myMap" :options="{streetViewControl: false}" :zoom="14" style="height: 100vh">
        <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" :content="infoContent" @closeclick="infoWinOpen=false"></gmap-info-window>
        <gmap-marker
        :key="i"
        v-for="(m, i) in markers"
        :position="m.position"
        :icon="m.icon"
        @click="toggleInfoWindow(m,i)"
      ></gmap-marker>
      </gmap-map>
      <notifications group="foo" position="bottom left" />
  </div>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import router from '../router'
export default {
  name: 'mapa',
  data () {
    return {
      nav: {
        edge: 'right'
      },
      GET_SERVICE_URL: 'https://evocloud-guepardos.appspot.com/api/Servicios/',
      interval: '',
      center: {
        lat: 6.2269243,
        lng: -75.5682957
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      servicio: {},
      mensajero: {},
      recogido: [],
      entregas: [],
      finalizado: [],
      waypts: [],
      lastPosition: [],
      totalEntregas: 0,
      kilometrosCirculo: 2.5,
      entregasDirecciones: [],
      estado: '',
      id: '',
      dibujarCirculos: true,
      mostrarMensajeRecogida: true
    }
  },
  mounted () {
    this.getData()
    this.interval = setInterval(function () {
      this.getData()
    }.bind(this), 10000)
  },
  methods: {
    getData () {
      let vm = this
      vm.$http.get(vm.GET_SERVICE_URL + vm.$route.params.id)
        .then(data => {
          vm.servicio = data.body
          vm.id = this.servicio.id.substr(-6)
          vm.finalizado = vm._.find(vm.servicio.fechaHoraEstados, function (o) { if (o.estado === 3) { return o } })
          if (vm.finalizado) {
            clearInterval(vm.interval)
          }
          vm.dibujarPuntos()
          vm.$http.get(vm.GET_SERVICE_URL + vm.$route.params.id + '/Mensajero/')
          .then(data => {
            vm.mensajero = data.body
            vm.$http.get(`http://backend.guepardos.co:3001/api/locations?filter[where][mensajeroId][like]=${vm.servicio.mensajeroId}&filter[limit]=1&filter[order]=fecha%20DESC`)
            .then(data => {
              if (data.body.length > 0) {
                vm.lastPosition = data.body[0].metadata.coords
              }
            })
          })
        }, () => {
          clearInterval(vm.interval)
          router.push('/')
        })
    },
    dibujarPuntos () {
      let vm = this
      vm.$refs.myMap.$mapCreated.then(function () {
        let geocoder = new google.maps.Geocoder()
        vm.markers = []
        vm.recogido = vm._.find(vm.servicio.fechaHoraEstados, function (o) { if (o.estado === 1) { return o } })
        if (vm.recogido) {
          if (vm.recogido.coordenadas.latitude === 0 && vm.recogido.coordenadas.longitude === 0) {
            vm.dinujarRecogida(vm.servicio.geoR.lat, vm.servicio.geoR.lng, true)
          } else {
            vm.dinujarRecogida(vm.recogido.coordenadas.latitude, vm.recogido.coordenadas.longitude, false)
          }
        } else {
          if (vm.mostrarMensajeRecogida) {
            vm.$notify({
              group: 'foo',
              title: 'Información',
              type: 'warning',
              text: 'El servicio ha sido asigando y está en proceso de ser recogido.',
              duration: -1
            })
          }
          vm.dinujarRecogida(vm.servicio.geoR.lat, vm.servicio.geoR.lng, true)
        }
        vm.mostrarMensajeRecogida = false
        if (vm.servicio.fechaHoraEntregas.length > 0) {
          vm.entregas = vm.servicio.fechaHoraEntregas
          vm.totalEntregas = vm.entregas.length
          vm._.forEach(vm.entregas, function (entrega, index) {
            vm.markers.push({
              position: {
                lat: entrega.coordenadas.latitude,
                lng: entrega.coordenadas.longitude
              },
              infoText: `Entrega ${index + 1}`,
              icon: require('../assets/entrega.png')
            })
          })
        } else {
          if (vm._.find(vm.servicio.fechaHoraEstados, function (o) { if (o.estado === 2) { return o } })) {
            vm.entregas.push(vm._.find(vm.servicio.fechaHoraEstados, function (o) { if (o.estado === 2) { return o } }))
            vm.totalEntregas = 1
            if (vm.entregas[0].coordenadas.latitude === 0 && vm.entregas[0].coordenadas.longitude === 0) {
              vm.entregas[0].coordenadas.latitude = vm.servicio.geoE.lat
              vm.entregas[0].coordenadas.longitude = vm.servicio.geoE.lng
            }
            vm.markers.push({
              position: {
                lat: vm.entregas[0].coordenadas.latitude,
                lng: vm.entregas[0].coordenadas.longitude
              },
              infoText: 'Entrega',
              icon: require('../assets/entrega.png')
            })
          }
        }
        if (vm.finalizado) {
          vm.getRoute()
        } else {
          vm.markers.push({
            position: {
              lat: parseFloat(vm.lastPosition.latitude),
              lng: parseFloat(vm.lastPosition.longitude)
            },
            infoText: `Mensajero: ${vm.mensajero.nombre}`,
            icon: require('../assets/mensajero.png')
          })
        }
        let index = vm.servicio.fechaHoraEstados.length
        let estado = 0
        if (index !== 0) {
          estado = vm.servicio.fechaHoraEstados[index - 1].estado
        }
        if (estado === 0) {
          vm.estado = 'Asignado'
        } else if (estado === 1) {
          if (vm.servicio.fechaHoraEntregas.length > 0) {
            vm.estado = 'Entregado'
          } else {
            if (vm.servicio.hasOwnProperty('modificaciones')) {
              if (vm.servicio.modificaciones.hasOwnProperty('entregadoPor')) {
                vm.estado = 'Entregado'
                let marker = {
                  position: {
                    lat: 6.2269243,
                    lng: -75.5682957
                  },
                  infoText: 'Un operario ha registrado esta entrega.',
                  icon: require('../assets/entrega.png')
                }
                vm.markers.push(marker)
                marker.direccion = 'Central Guepardos'
                marker.index = vm.markers.length - 1
                vm.entregasDirecciones = []
                vm.entregasDirecciones.push(marker)
              } else {
                vm.estado = 'Recogido'
              }
            } else {
              vm.estado = 'Recogido'
            }
          }
        } else if (estado === 2) {
          vm.estado = 'Entregado'
        } else if (estado === 3) {
          vm.estado = 'Finalizado'
        }
      })
    },
    dinujarRecogida (lat, lng, tipo) {
      let vm = this
      if (tipo) {
        vm.infoText = 'Punto de Recogida'
      } else {
        vm.infoText = 'Recogida'
      }
      vm.markers.push({
        position: {
          lat: lat,
          lng: lng
        },
        infoText: vm.infoText,
        icon: require('../assets/home.png')
      })
      let center = {lat: lat, lng: lng}
      vm.center = {lat: lat, lng: lng}
      if (vm.dibujarCirculos) {
        vm.dibujarCirculos = false
        vm.$refs.myMap.resizePreserveCenter()
        let cityCircle1 = new google.maps.Circle({
          strokeColor: '#02C3BD',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#02C3BD',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: (5) * 1000
        })
        let cityCircle2 = new google.maps.Circle({
          strokeColor: '#00B9AE',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#00B9AE',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: (12) * 1000
        })
        let cityCircle3 = new google.maps.Circle({
          strokeColor: '#009F93',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#009F93',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: (18) * 1000
        })
        let cityCircle4 = new google.maps.Circle({
          strokeColor: '#037171',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#037171',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: (24) * 1000
        })
        let cityCircle5 = new google.maps.Circle({
          strokeColor: '#03312E',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#03312E',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: (29) * 1000
        })
      }
    },
    getRoute () {
      var vm = this
      vm.directionsService = new google.maps.DirectionsService()
      vm.directionsDisplay = new google.maps.DirectionsRenderer({
        'draggable': false,
        suppressMarkers: true
      })
      vm.directionsDisplay.setMap(vm.$refs.myMap.$mapObject)
      vm._.forEach(vm.entregas, function (entrega, index) {
        vm.waypts.push({
          location: { 'lat': entrega.coordenadas.latitude, 'lng': entrega.coordenadas.longitude },
          stopover: true
        })
      })
      vm.directionsService.route({
        origin: new google.maps.LatLng(vm.recogido.coordenadas.latitude, vm.recogido.coordenadas.longitude),
        destination: new google.maps.LatLng(vm.entregas[vm.entregas.length - 1].coordenadas.latitude, vm.entregas[vm.entregas.length - 1].coordenadas.longitude),
        waypoints: vm.waypts,
        optimizeWaypoints: true,
        travelMode: 'DRIVING'
      }, function (response, status) {
        if (status === 'OK') {
          vm.directionsDisplay.setDirections(response)
          vm.$refs.myMap.resizePreserveCenter()
        } else {
          console.log('Directions request failed due to ' + status)
        }
      })
    },
    toggleInfoWindow (marker, idx) {
      this.infoWindowPos = marker.position
      this.infoContent = marker.infoText
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    }
  },
  notifications: {
    notificacionRecogido: {
      title: 'Información',
      message: 'El servicio ha sido asigando y está en proceso de ser recogido.',
      type: 'info',
      timeout: 9000
    },
    notificacionMensajero: {
      title: 'Información',
      message: 'El mensajero tiene problemas de geolocalización.',
      type: 'info',
      timeout: 9000
    },
    notificacionBadPosition: {
      title: 'Información',
      message: 'El servicio cuenta con problemas en la geolocalización.',
      type: 'info',
      timeout: 9000
    }
  }
}
</script>
<style>
.side-nav {
  position: fixed;
  width: 300px;
  left: 0;
  top: 0;
  margin: 0;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
  height: 100%;
  height: calc(100% + 60px);
  height: -moz-calc(100%);
  padding-bottom: 60px;
  background-color: #fff;
  z-index: 999;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  overflow-y: auto;
  will-change: transform;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: translateX(-105%);
  transform: translateX(-105%);
}
</style>



// WEBPACK FOOTER //
// Mapa.vue?8e2374e4